import { ArrowType, IndicatorType } from '../enums';
import { Arrow } from './Arrow';
export class PolygonalArrow extends Arrow {
    constructor(tourSceneGuid) {
        super(tourSceneGuid);
        this.arrowPositionConfiguration = {
            arrowPosition: {
                arrowArea: [],
                indicatorType: IndicatorType.PolygonalShape,
                indicatorScale: 1,
                indicatorPosition: 0,
            },
            arrowPositionType: ArrowType.Polygon,
        };
    }
}
